module.exports = __webpack_public_path__ + "img/2026announcement.9a7462ff.png";